import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';

import theme from './AvatarUploadIncorrectExtension.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  fileType: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};


const titleMessage = { id: 'Media.Create.InvalidFileDialog.Title', defaultMessage: '** File type not supported' };
const bodyMessage = {
  id: 'Media.Create.InvalidFileDialog.Body',
  defaultMessage: '** Files of type { fileType } can not be uploaded. Please select a different file',
};
const cancelButtonMessage = { id: 'General.Close', defaultMessage: '** Close' };

const AvatarUploadIncorrectExtension = ({ intl, fileType, onCancel }) => (
  <React.Fragment>
    <div className={ theme.root }>
      <div className={ theme.header }>
        <div>
          <FormattedMessage { ...titleMessage } />
        </div>
        <div onClick={ onCancel } className={ theme.closingIconContainer }>
          <Icon name="naked-x" />
        </div>
      </div>
      <div className={ theme.content }>
        <FormattedMessage
          { ...bodyMessage }
          values={{ fileType }}
        />
      </div>
      <div className={ theme.footer }>
        <Button
          label={ intl.formatMessage({ ...cancelButtonMessage }) }
          labelColor="blackMedium"
          className={ theme.cancelButton }
          onClick={ onCancel }
          buttonType="naked"
        />
      </div>
    </div>
  </React.Fragment>
);

AvatarUploadIncorrectExtension.propTypes = propTypes;

export default injectIntl(AvatarUploadIncorrectExtension);
